import type { indicator } from '../../../types/interfaces';

export const NOSIS_TOP_SCORE_CODES = [
  'NOSIS_001',
  'NOSIS_002',
  'NOSIS_003',
  'NOSIS_005',
] as const;

export type NosisTopScoreCode = (typeof NOSIS_TOP_SCORE_CODES)[number];

export const NOSIS_CHECK_DETAIL_INDICATOR_CODES = Array.from(
  { length: 19 },
  (_, i) => `NOSIS_${String(i + 11).padStart(3, '0')}`,
);

const LEGACY_TOP_CODE_SET = new Set<string>(NOSIS_TOP_SCORE_CODES);
const CHECK_DETAIL_CODE_SET = new Set<string>(NOSIS_CHECK_DETAIL_INDICATOR_CODES);

export function resolveNosisTopScoreCodes(options?: {
  isAtlanticLayout?: boolean;
  configuredCodes?: readonly string[];
}): readonly string[] {
  if (options?.configuredCodes?.length) {
    return options.configuredCodes;
  }
  return NOSIS_TOP_SCORE_CODES;
}

export function isNosisTopScoreCode(
  code: string | null | undefined,
  topScoreCodes: readonly string[] = NOSIS_TOP_SCORE_CODES,
): boolean {
  if (!code) return false;
  return topScoreCodes.includes(code);
}

export function filterNosisDetailIndicators(
  indicators: indicator[],
  options?: {
    excludeTopScoreCodes?: boolean;
    topScoreCodes?: readonly string[];
  },
): indicator[] {
  const withoutCheckDetail = indicators.filter(
    (ind) => !CHECK_DETAIL_CODE_SET.has(ind.code ?? ''),
  );
  if (options?.topScoreCodes?.length) {
    const topCodes = new Set(options.topScoreCodes);
    return withoutCheckDetail.filter((ind) => !topCodes.has(ind.code ?? ''));
  }
  if (!options?.excludeTopScoreCodes) {
    return withoutCheckDetail.slice(4);
  }
  return withoutCheckDetail.filter(
    (ind) => !LEGACY_TOP_CODE_SET.has(ind.code ?? ''),
  );
}

export function findNosisIndicatorByCode(
  indicators: indicator[],
  code: string,
): indicator | undefined {
  return indicators.find((ind) => ind.code === code);
}

export function findNosisIndicatorByLabel(
  indicators: indicator[],
  label: string,
): indicator | undefined {
  const needle = label.toLowerCase();
  return indicators.find(
    (item) => item.description?.toLowerCase().indexOf(needle) !== -1,
  );
}
